export const seo_meta = {
    home: {
        title: 'Hoops Indonesia | First & Biggest Official Basketball Store in Indonesia',
        description:
            'Hoops indonesia adalah toko sepatu dan perlengkapan basket terlengkap dan terbesar di indonesia. Produk original dari Nike, Jordan, adidas, dan brand lainnya. 100% asli! Gratis ongkir se-Indonesia.'
    },
    product_list: {
        title: 'Product List | Hoops Indonesia',
        description:
            'Hoops Indonesia, toko basket resmi dan terbesar di Indonesia. Temukan berbagai pilihan sepatu, jersey, aksesori, dan berbagai produk original lainnya'
    },
    men_shoe: {
        title: 'Jual Sepatu Basket Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi sepatu basket pria original terlengkap di Hoops Indonesia. Temukan berbagai pilihan footwear, mulai Air Jordan hingga brand ternama lainnya'
    },
    men_tshirt: {
        title: 'Jual Kaos Basket Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi kaos basket pria original terlengkap di Hoops Indonesia. Temukan berbagai pilihan T-shirt basket keren dari brand ternama. Produk 100% original'
    },
    men_jersey: {
        title: 'Jual Jersey Basket Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi jersey basket pria original terlengkap dari tim NBA. Jersey basket berkualitas dengan jaminan 100% original hanya di Hoops Indonesia.'
    },
    men_pants: {
        title: 'Jual Celana Basket Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi celana basket pria original terlengkap di Hoops Indonesia. Pilihan celana pendek basket original berkualitas. Cek dan beli sekarang!'
    },
    men_jacket: {
        title: 'Jual Jaket Basket Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi jaket basket pria original terlengkap di Hoops Indonesia. Pilihan produk original hoodie dan jaket basket keren dari brand ternama untuk gaya sporty.'
    },
    men_slide: {
        title: 'Jual Sandal Slide Pria Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi sandal slide pria original terlengkap di Hoops Indonesia. Pilihan sandal slop basket nyaman original dari brand ternama untuk gaya kasual Anda.'
    },
    kids_shoe: {
        title: 'Jual Sepatu Basket Anak | Hoops Indonesia',
        description:
            'Jual sepatu basket anak original di Hoops Indonesia. Nyaman, kuat, dan aman untuk aktivitas basket anak sehari-hari.'
    },
    ball: {
        title: 'Jual Bola Basket Original | Hoops Indonesia',
        description:
            'Koleksi bola basket original di Hoops Indonesia. Cocok untuk indoor dan outdoor, grip kuat, dan tahan lama digunakan.'
    },
    backpack: {
        title: 'Jual Tas olahraga & Backpack | Hoops Indonesia',
        description:
            'Temukan tas basket dan backpack original di Hoops Indonesia. Desain sporty, kuat, dan praktis untuk latihan maupun harian.'
    },
    cap: {
        title: 'Jual Caps Original | Hoops Indonesia',
        description:
            'Koleksi topi basket original di Hoops Indonesia. Desain sporty, nyaman dipakai, cocok untuk gaya kasual dan olahraga.'
    },
    sock: {
        title: 'Jual Kaos Kaki Produk Original | Hoops Indonesia',
        description:
            'Kaos kaki basket original di Hoops Indonesia. Nyaman, menyerap keringat, dan mendukung performa saat bermain basket.'
    },
    accessories: {
        title: 'Jual Aksesoris Basket Original | Hoops Indonesia',
        description:
            'Lengkapi kebutuhan basket dengan aksesoris original di Hoops Indonesia. Fungsional, berkualitas, dan siap mendukung permainan.'
    },
    headband: {
        title: 'Headband Aksesoris | Hoops Indonesia',
        description:
            'Headband aksesoris basket original di Hoops Indonesia. Membantu menyerap keringat dan menjaga kenyamanan saat bermain basket.'
    },
    women_shoe: {
        title: 'Sepatu Basket Wanita Original & Terbaru',
        description:
            'Koleksi sepatu basket wanita original terlengkap di Hoops Indonesia. Temukan berbagai pilihan women footwear mulai dari Air Jordan hingga brand ternama lainnya.'
    },
    women_tshirt: {
        title: 'T-Shirt Basket Wanita Original | Hoops Indonesia',
        description:
            'Koleksi kaos basket wanita original di Hoops Indonesia. Tersedia berbagai pilihan t-shirt basket kasual yang nyaman digunakan sehari-hari.'
    },
    women_jacket: {
        title: 'Jaket Basket Jordan Wanita Original | Hoops Indonesia',
        description:
            'Koleksi jaket basket wanita Jordan original di Hoops Indonesia. Pilihan jaket wanita dengan desain sporty dan nyaman untuk aktivitas harian.'
    },
    women_slide: {
        title: 'Sandal Slide Wanita Original & Nyaman | Hoops Indonesia',
        description:
            'Koleksi sandal slide wanita original di Hoops Indonesia. Tersedia berbagai pilihan sandal slip-on dari Nike dan Jordan yang nyaman untuk aktivitas santai dengan desain sporty.'
    },
    women_pants: {
        title: 'Celana Basket Wanita Original & Sporty | Hoops Indonesia',
        description:
            'Koleksi celana basket wanita Nike original di Hoops Indonesia. Celana panjang wanita dengan desain sporty dan nyaman untuk aktivitas basket maupun harian.'
    },
    wristband: {
        title: 'Wristband Basket Original & Terbaru | Hoops Indonesia',
        description:
            'Koleksi wristband basket original & terbaru di Hoops Indonesia. Aksesori olahraga yang membantu menyerap keringat dan menunjang kenyamanan saat bermain basket.'
    }
}